module.exports = "mutation DeleteEmployee($data:DeleteEmployeeInput!){deleteEmployee(data:$data){__typename success}}"